const { CookiesConsentManager } = require('@deliveroo/cookies-consent');
const { getCookiesConsentMode } = require('./helpers');

// if the cookie is not marked as "strictly necessary" in OneTrust,
// users will be able to disable it in their cookie preferences.
// please consider this when you're trying to use the cookie!
const getStrictlyNecessaryServerCookie = (req, key) => req && req.cookies && req.cookies[key];

// if you're using this method, your cookie must be categorised as
// "strictly necessary" in OneTrust. otherwise, please use the
// `maybeSetServerCookie` method and add your cookie to the
// `getCookieType()` method!
const setStrictlyNecessaryServerCookie = (req, res, key, val, options = undefined) => {
  req.cookies[key] = val;
  res.cookie(key, val, options);
};

// OneTrust isn't able to prevent us from setting server-side cookies,
// so we have to self-police this.
const maybeSetServerCookie = (req, res, key, val, options = undefined) => {
  const cookieConsentManager = new CookiesConsentManager(
    req.cookies.OptanonConsent,
    getCookiesConsentMode(),
  );
  const cookieAllowed = cookieConsentManager.isCookieAllowed(key);

  if (cookieAllowed) {
    req.cookies[key] = val;
    res.cookie(key, val, options);
  }
};

/* This method can be used for tracking purposes, to check whether a user has consented to a given cookie.
If you're trying to set a cookie, please use the `maybeSetServerCookie` which will handle everything for you! */
const isServerCookieAllowed = (req, key) => {
  const cookieConsentManager = new CookiesConsentManager(
    req.cookies.OptanonConsent,
    getCookiesConsentMode(),
  );

  return cookieConsentManager.isCookieAllowed(key);
};

module.exports = {
  getStrictlyNecessaryServerCookie,
  setStrictlyNecessaryServerCookie,
  maybeSetServerCookie,
  isServerCookieAllowed,
};
